<template>
  <div>
    <transition name="slide-in-left">
      <div
        v-show="$store.state.isBottomBarVisible"
        class="right-sidebar"
        :class="[{ 'dir-rtl': language.dir === 'rtl' }, { 'right-sidebar--subnav': newConfig.general.useSidebarSubnavigation }]"
        :dir="language.dir"
        :style="`
          background: ${newConfig.RightSidebar?.['background-colour']};
        `"
        @click="clearTimeout"
      >
        <div class="right-sidebar__brand-logo" v-if="config.generalSidebarBrandLogo">
          <!-- video -->
          <video v-if="isVideo(config.generalSidebarBrandLogo)" :src="`${$store.state.assetsPath}${config.generalSidebarBrandLogo}`" autoplay loop muted playsinline></video>

          <!-- anything else/image -->
          <img v-else :src="`${$store.state.assetsPath}${config.generalSidebarBrandLogo}`" alt="" />
        </div>

        <div class="right-sidebar__layout" :class="{ 'right-sidebar__layout--subnav': newConfig.general.useSidebarSubnavigation }">
          <div class="right-sidebar__content">
            <div v-if="showMinimapTop && activeContent.minimap" class="right-sidebar__minimap-wrapper">
              <transition name="right-sidebar-minimap-crossfade">
                <img :src="`${$store.state.assetsPath}${activeContent.minimap}`" :key="activeContent.minimap" class="right-sidebar__minimap" alt="" />
              </transition>
            </div>
            <div class="spacer"></div>
            <div v-if="activeContent.subsectionShortcuts?.length" key="shortcuts" class="right-sidebar__shortcuts">
              <div v-for="shortcut in activeContent.subsectionShortcuts" :key="shortcut.subsectionId" class="shortcut-wrapper">
                <button class="btn touch" :key="shortcut.subsectionId" @click="navigationToSubsection(shortcut.subsectionId)">
                  {{ shortcut.label[language.code] || shortcut.label.en }}
                </button>
              </div>
            </div>
            <transition name="sidebar-fade">
              <div v-if="activeContent.heading" :key="activeContent.heading" class="right-sidebar__heading" v-html="activeContent.heading" />
            </transition>
            <transition name="sidebar-fade">
              <div v-if="activeContent.description" :key="activeContent.description" class="right-sidebar__description" v-html="activeContent.description" />
            </transition>
            <transition name="sidebar-fade">
              <div v-if="!showMinimapTop && activeContent.minimap" class="right-sidebar__minimap-wrapper">
                <transition name="right-sidebar-minimap-crossfade">
                  <img :src="`${$store.state.assetsPath}${activeContent.minimap}`" :key="activeContent.minimap" class="right-sidebar__minimap" alt="" />
                </transition>
              </div>
            </transition>
            <transition name="sidebar-fade">
              <MarkerGuide v-if="!newConfig.general.showProductCountWidget && newConfig.rightSidebar.propertyGuide.active && activeContent.markerGuide" class="right-sidebar__marker-guide" :key="activeContent.markerGuide" />
            </transition>
            <transition name="sidebar-fade">
              <div v-if="activeContent.qrUrl" :key="activeContent.qrUrl" class="right-sidebar__qr-wrapper">
                <div class="right-sidebar__qr">
                  <div class="right-sidebar__qr-row">
                    <qrcode-vue class="qrcode" :value="activeContent.qrUrl" size="1000" renderAs="canvas" :key="activeContent.qrUrl" background="transparent" foreground="#ffffff" />
                    <div class="right-sidebar__qr-message">{{ activeContent.qrMessage[language.code] || activeContent.qrMessage.en }}</div>
                  </div>
                </div>
              </div>
            </transition>
            <transition name="sidebar-fade">
              <div v-if="activeContent.virtualTourUrl" :key="activeContent.virtualTourUrl" class="right-sidebar__qr-wrapper">
                <div class="right-sidebar__qr">
                  <div class="right-sidebar__qr-row">
                    <button class="btn touch" @click="$store.commit('property/SET_ACTIVE_VIRTUAL_TOUR_URL', activeContent.virtualTourUrl)">{{ activeContent.virtualTourButtonLabel.en }}</button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <transition name="sidebar-fade">
            <SidebarSubnavigation class="right-sidebar__subnav" v-if="newConfig.general.useSidebarSubnavigation && $store.getters.activeSidebarSubnavigation.length > 1" key="subnav" :nav-items="$store.getters.activeSidebarSubnavigation" />
          </transition>
          <transition name="sidebar-fade">
            <div v-if="activeSubsection && activeSubsection.issuuEmbedUrl[language.code]" class="right-sidebar__back-wrapper">
              <button
                v-if="!$store.state.actions.showIframeUrl"
                class="btn touch"
                @click="
                  $store.commit('actions/SET_IFRAME_URL', activeSubsection.issuuEmbedUrl[language.code]);
                  $store.commit('sidebar/CLOSE_SLIDEOUT');
                "
              >
                <span>View Brochure</span>
              </button>
              <button v-else class="btn touch" @click="$store.commit('actions/SET_IFRAME_URL', '')">
                <span>Close Brochure</span>
              </button>
            </div>
          </transition>
          <transition name="sidebar-fade">
            <div v-if="activeContent && activeContent.iframes && activeContent.iframes[language.code] && activeContent.iframes[language.code].length" class="right-sidebar__back-wrapper">
              <button
                v-for="iframe in activeContent.iframes[language.code]"
                :key="iframe.url"
                class="btn touch"
                @click="
                  $store.commit('actions/SET_IFRAME_URL', iframe.url);
                  $store.commit('sidebar/CLOSE_SLIDEOUT');
                "
              >
                <span>{{ iframe.label }}</span>
              </button>
            </div>
          </transition>
          <transition name="sidebar-fade">
            <div v-if="activeContent && activeContent.issuuEmbedUrl" class="right-sidebar__back-wrapper">
              <button
                v-if="!$store.state.actions.showIframeUrl"
                class="btn touch"
                @click="
                  $store.commit('actions/SET_IFRAME_URL', activeContent.issuuEmbedUrl);
                  $store.commit('sidebar/CLOSE_SLIDEOUT');
                "
              >
                <span>View Brochure</span>
              </button>
              <button v-else class="btn touch" @click="$store.commit('actions/SET_IFRAME_URL', '')">
                <span>Close Brochure</span>
              </button>
            </div>
          </transition>
          <transition name="sidebar-fade">
            <div v-if="newConfig.general?.disclaimer" class="right-sidebar__disclaimer" v-html="newConfig.general?.disclaimer"></div>
          </transition>
        </div>
        <transition name="sidebar-fade">
          <div v-if="config.generalSidebarLogo" class="right-sidebar__logo">
            <video v-if="isVideo(config.generalSidebarLogo)" :src="`${$store.state.assetsPath}${config.generalSidebarLogo}`" autoplay loop muted playsinline></video>
            <img v-else :src="`${$store.state.assetsPath}${config.generalSidebarLogo}`" alt="" />
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import QrcodeVue from "qrcode.vue";
import MarkerGuide from "./MarkerGuide.vue";
import SidebarSubnavigation from "./SidebarSubnavigation";
import _ from "lodash";
import { bus } from "../main";
import { buildSubsectionPath, isRouteActiveForPath } from "@/utils/livingRoute";

export default {
  props: ["content"],

  components: { QrcodeVue, MarkerGuide, SidebarSubnavigation },

  data() {
    return {
      activeContent: {
        description: null,
        filterType: null,
        heading: null,
        issuuEmbedUrl: null,
        markerGuide: null,
        minimap: null,
        qrMessage: null,
        qrUrl: null,
        virtualTourButtonLabel: null,
        virtualTourUrl: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      activeSubsection: "property/activeSubsection",
      activeLivingOption: "property/activeLivingOption",
      config: "config",
      backlink: "activeBackLink",
      newConfig: "newConfig",
      shouldSlideOutAutoOpen: "sidebar/shouldSlideOutAutoOpen",
      subsections: "property/subsections",
    }),

    activeSubsectionId() {
      return this.$store.state.route.query.activeSubsectionId;
    },

    isSlideOutVisible() {
      return this.$store.getters["sidebar/isSlideOutVisible"];
    },

    language() {
      return this.$store.getters.language;
    },

    isNowSellingRoute() {
      return this.$route.name !== "page";
    },

    showMinimapTop() {
      if (this.isNowSellingRoute && this.newConfig.minimapPositionNowSelling === "top") return true;
      if (!this.isNowSellingRoute && this.newConfig.minimapPositionPage === "top") return true;
      return false;
    },
  },

  watch: {
    content: {
      handler(newContent, oldContent) {
        if (!_.isEqual(oldContent, newContent) && !_.isEmpty(newContent)) {
          this.$store.commit("addAnimationToQueue", "SideBar");
        }
      },
      immediate: true,
    },
  },

  mounted() {
    bus.$on("animateSideBar", () => {
      if (this.activeContent.description !== this.content.description) this.activeContent.description = null;
      if (this.activeContent.filterType !== this.content.filterType) this.activeContent.filterType = null;
      if (this.activeContent.heading !== this.content.heading) this.activeContent.heading = null;
      if (this.activeContent.issuuEmbedUrl !== this.content.issuuEmbedUrl) this.activeContent.issuuEmbedUrl = null;
      if (this.activeContent.markerGuide !== this.content.markerGuide) this.activeContent.markerGuide = null;
      if (this.activeContent.minimap !== this.content.minimap && !this.content.minimap) {
        this.activeContent.minimap = null;
      }
      if (this.activeContent.qrMessage !== this.content.qrMessage) this.activeContent.qrMessage = null;
      if (this.activeContent.qrUrl !== this.content.qrUrl) this.activeContent.qrUrl = null;
      if (this.activeContent.virtualTourButtonLabel !== this.content.virtualTourButtonLabel) this.activeContent.virtualTourButtonLabel = null;
      if (this.activeContent.virtualTourUrl !== this.content.virtualTourUrl) this.activeContent.virtualTourUrl = null;
      if (this.activeContent.subsectionShortcuts !== this.content.subsectionShortcuts) this.activeContent.subsectionShortcuts = null;

      setTimeout(() => {
        this.$set(this.activeContent, "description", this.content.description);
        this.$set(this.activeContent, "filterType", this.content.filterType);
        this.$set(this.activeContent, "heading", this.content.heading);
        this.$set(this.activeContent, "issuuEmbedUrl", this.content.issuuEmbedUrl);
        this.$set(this.activeContent, "markerGuide", this.content.markerGuide);
        this.$set(this.activeContent, "minimap", this.content.minimap);
        this.$set(this.activeContent, "qrMessage", this.content.qrMessage);
        this.$set(this.activeContent, "qrUrl", this.content.qrUrl);
        this.$set(this.activeContent, "virtualTourButtonLabel", this.content.virtualTourButtonLabel);
        this.$set(this.activeContent, "virtualTourUrl", this.content.virtualTourUrl);
        this.$set(this.activeContent, "subsectionShortcuts", this.content.subsectionShortcuts);

        bus.$emit("finishedAnimation", "SideBar");
      }, 500);

      if (this.shouldSlideOutAutoOpen) {
        setTimeout(() => {
          this.$store.commit("sidebar/OPEN_SLIDEOUT");
        }, 2000);
      }
    });
  },

  methods: {
    ...mapActions(["triggerVideo"]),

    isVideo(path) {
      return /\.mp4(\?|$)/i.test(path || "");
    },

    clearTimeout() {
      this.$store.commit("sidebar/CLEAR_SIDEBAR_CLOSE_TIMEOUT");
    },

    isNavItemActive(item) {
      if (isRouteActiveForPath(this.$route, item.to)) {
        return true;
      }
    },

    toggleSlideOut() {
      if (!this.$store.state.property.activeVirtualTourUrl) {
        if (this.isSlideOutVisible) {
          this.$store.commit("sidebar/CLOSE_SLIDEOUT");
        } else {
          this.$store.commit("sidebar/OPEN_SLIDEOUT");
        }
      }
    },

    getSubsectionById(id) {
      const subsection = this.subsections.find((subsection) => subsection._id === id);

      if (!subsection) return null;

      return subsection;
    },

    navigationToSubsection(id) {
      const subsectionId = this.$route.params.subsectionId;
      const { livingOptionId } = this.getSubsectionById(id);

      if (subsectionId) {
        this.$router.push({ path: buildSubsectionPath(this.$route, livingOptionId, id, `?activeSubsectionId=${id}`), query: { ignoreHistory: true } });
      }
    },
  },
};
</script>
<style lang="scss">
.right-sidebar {
  background: var(--sidebar-bg-color);
  height: 98rem;
  position: absolute;
  right: 0;
  top: 0;
  width: 32.5rem;
  z-index: var(--sidebar-z-index);

  .spacer {
    flex-grow: 1;
  }

  .layout-switched & {
    top: 10rem;
  }

  &__layout {
    padding: 12rem 0 6rem;
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-end;
  }

  &__content {
    margin-bottom: 3rem;
    margin-top: 3rem;
    position: relative;
    z-index: 10;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  &__brand-logo {
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 10;

    img,
    video {
      height: 100%;
      object-fit: contain;
      width: 100%;
    }
  }

  &__logo {
    bottom: 0;
    height: 5rem;
    position: absolute;
    right: 0;
    width: calc(100% - 5rem);
    z-index: 20;

    img,
    video {
      height: 100%;
      object-fit: contain;
      object-position: bottom right;
      width: 100%;
    }
  }

  &__minimap-wrapper {
    display: grid;
    position: relative;
    z-index: 10;
  }

  &__minimap {
    grid-area: 1 / 1;
    width: 100%;
    height: 100%;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    object-fit: contain;
    object-position: top;
  }

  &__shortcuts {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 0 0 1rem;
    padding: 0 3rem;

    .shortcut-wrapper {
      display: flex;
      justify-content: center;

      button {
        border: 0.1rem solid #fff;
        font-size: 1.4rem;
        padding: 0.75rem 0;
        text-transform: uppercase;
        width: 100%;
      }
    }
  }

  &__heading {
    align-items: flex-end;
    color: var(--sidebar-heading-color);
    display: flex;
    font-size: 1.8rem;
    font-weight: var(--font-weight);
    letter-spacing: 0.05em;
    line-height: 1.2;
    padding-bottom: 1rem;
    padding-left: 5rem;
    padding-right: 5rem;
    // position: absolute;
    top: 0;
    left: 0;
    // height: 100%;
    width: 100%;
    text-transform: uppercase;
  }

  &__description-wrapper {
    position: relative;
  }

  &__description {
    color: var(--sidebar-copy-color);
    font-size: 1.1rem;
    font-weight: var(--font-weight-secondary);
    letter-spacing: 0.05em;
    line-height: 1.5rem;
    margin: 0 0 1rem;
    padding-left: 5rem;
    padding-right: 5rem;
    width: 100%;

    ul {
      padding-inline-start: 0;
    }
  }

  &__disclaimer {
    color: var(--sidebar-disclaimer-color);
    bottom: 0;
    font-size: 0.5rem;
    font-weight: var(--font-weight-secondary);
    letter-spacing: 0.05em;
    line-height: 1.1em;
    margin: 0 0 1rem;
    opacity: 0.15;
    padding-left: 2rem;
    padding-right: 2rem;
    position: absolute;
    font-style: italic;
    width: 100%;
    z-index: 10;
  }

  &__marker-guide {
    color: var(--sidebar-copy-color);
    font-size: 1.1rem;
    font-weight: var(--font-weight-secondary);
    letter-spacing: 0.05em;
    line-height: 1.5rem;
    margin: 2rem 0 1rem;
    padding-left: 5rem;
    padding-right: 5rem;
    width: 100%;
  }

  &__back-wrapper {
    margin: 2rem 0 1rem;
    padding-left: 5rem;
    padding-right: 5rem;
    width: 100%;
    z-index: 10;

    .btn {
      align-items: center;
      border: 0.1rem solid #fff;
      border-radius: var(--border-radius);
      font-size: var(--button-font-size);
      height: var(--button-height);
      display: flex;
      padding: var(--button-padding);
      text-transform: uppercase;
    }
  }

  // &__back {
  //   display: flex;
  //   font-size: 1.1rem;
  //   font-weight: 400;
  //   height: 100%;
  //   letter-spacing: 0.05em;
  //   line-height: 1.5rem;
  //   overflow: hidden;
  //   padding: 1rem 0;
  //   width: 100%;

  //   .btn {
  //     align-items: center;
  //     border: 0.1rem solid #fff;
  //     border-radius: var(--border-radius);
  //     font-size: var(--button-font-size);
  //     height: var(--button-height);
  //     display: flex;
  //     padding: var(--button-padding);
  //     text-transform: uppercase;
  //   }

  //   svg {
  //     margin-left: 0;
  //     margin-right: 1rem;

  //     [dir="rtl"] & {
  //       margin-left: 1rem;
  //       margin-right: 0;
  //     }
  //   }
  // }

  &__qr-wrapper {
    position: relative;
  }

  &__qr {
    margin: 2rem 0 1rem;
    padding-left: 5rem;
    padding-right: 5rem;
    width: 100%;

    &-heading {
      font-size: 1.2rem;
      font-weight: var(--font-weight);
      margin-bottom: 1.2rem;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    &-row {
      display: flex;
      // height: 6.75rem;
    }

    &-message {
      font-size: 1.1rem;
      font-weight: var(--font-weight-secondary);
      letter-spacing: 0.05em;
      line-height: 1.5rem;
      padding-left: 1.75rem;
      padding-right: 4rem;
    }
  }

  .slide-out {
    background: rgba(#000, 0.8);
    border-radius: 0.5rem 0 0 0.5rem;
    bottom: 10rem;
    padding: 3rem;
    pointer-events: all;
    position: absolute;
    right: 100%;
    transform: translateX(calc(100% - 2rem));
    transition: all 0.6s ease-in-out;
    width: 25rem;

    &--visible {
      transform: none;

      svg {
        transform: scaleX(-1);
      }
    }

    svg {
      transition: transform 0.6s ease-in-out;
    }

    &__toggle-button {
      align-items: center;
      background: rgba(#000, 0.8);
      border-radius: 0.5rem 0 0 0.5rem;
      bottom: 4rem;
      display: flex;
      font-size: 2rem;
      height: 4rem;
      padding-left: 1.3rem;
      pointer-events: auto;
      position: absolute;
      right: 100%;
      width: 4rem;
    }
  }

  .qrcode {
    display: inline-block;
    padding: 0.4rem;

    canvas {
      height: 10rem !important;
      width: 10rem !important;
    }
  }

  &__subnav {
    padding-left: 5rem;
    padding-right: 5rem;
    position: relative;
  }
}

.bottom-bar__nav-item-wrapper a {
  pointer-events: auto;
}

.right-sidebar-minimap-crossfade-enter-active,
.right-sidebar-minimap-crossfade-leave-active {
  transition: opacity 0.4s ease-in-out;
}

.right-sidebar-minimap-crossfade-enter,
.right-sidebar-minimap-crossfade-leave-to {
  opacity: 0;
}
</style>
